<template>
  <div class="liveblog item-liveblog">
    <div v-if="loading" class="spinner"></div>
    <div v-else>
		<div class="liveblog-head" v-if="!options.compact && options.live">
			<span class="liveblog-btn" v-on:click.stop.prevent="renderQueue">Live Updates</span>
			
			<span v-if="queue.length" class="liveblog-btn btn-queue" v-on:click.stop.prevent="renderQueue">{{ queue.length }} νέα μηνύματα</span>
			
		</div>
		<div class="liveblog-messages">
		
			<div class="live-msg" v-bind:id="'message-' + message.id" v-for="(message) in messages"
				v-bind:key="message.id">
				<div class="msg-block">
					<div class="msg-date">
						<span class="msg-day">{{ message.createdDate }}</span><span class="msg-time">{{ message.createdTime }}</span>
					</div>
					<div class="msg-info" v-if="!options.compact">
						<span class="msg-avatar">
							<img v-bind:src="message.authorImage" />
						</span>
						<span class="msg-author">{{ message.author }}</span>
					</div>
					<div class="msg-content">
					<h3 v-if="message.title" class="msg-title">{{ message.title }}</h3>
					<div v-if="!options.compact" class="msg-text" v-html="message.text"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
    <a v-if="pagination" class="liveblog-pagination-button btn-box" v-on:click.stop.prevent="paginate">ΠΕΡΙΣΣΟΤΕΡΑ</a>
  </div>
</template>
<script>
import io from 'socket.io-client';
import axios from 'axios';
export default {
  name: 'LiveBlog',
  props: {
    options: Object
  },
  data() {
    return {
      messages: [],
      queue: [],
      loading: true,
      pagination: false,
      lastId: null,
      timeout: null,
      ads: [],
	  live: false
    }
  },
  mounted: function () {
    if (this.options.live) {
		this.live = true;
      this.connect();
    } else if (this.options.data) {
      this.messages = this.options.data;
      this.pagination = this.options.pagination;
      this.loading = false;
    }
  },
  updated: function () {
	
	/*
    if (this.$refs.ads && window.googletag) {
      this.$refs.ads.forEach((ad) => {
        if (this.ads.indexOf(ad.id) === -1) {
          this.ads.push(ad.id);
          window.googletag.cmd.push(() => {
            window.googletag.defineSlot(this.options.adSlot, [
              [300, 250]
            ], ad.id).addService(window.googletag.pubads());
          });
          window.googletag.cmd.push(() => {
            window.googletag.display(ad.id);
          });
        }
      });
    }
	*/
  },
  methods: {
    connect: function () {
      this.socket = io(this.options.server, {
        transports: ['websocket']
      });
      this.socket.emit('join', {
        room: this.options.namespace + ':' + this.options.id,
        limit: this.options.limit
      });
      this.socket.on('save', (data) => {
        this.onSave(data);
      });
      this.socket.on('delete', (data) => {
        this.onDelete(data);
      });
      this.socket.on('sync', (data) => {
        this.onSync(data);
      });
      this.socket.on('pagination', (data) => {
        this.onPaginate(data);
      });
    },

    onSave: function (data) {
      var index = this.findIndex(data.id);
      if (index === -1) {
        if (this.options.compact) {
          this.messages.unshift(data);
          if (this.messages.length > this.options.limit) {
            this.messages.pop();
          }
        } else {
          this.messages.unshift(data);
          this.postprocess();
          if (!this.isVisible()) {
            this.queue.unshift(data);
          }
        }
      } else {
        this.$set(this.messages, index, data);
        this.postprocess();
      }
    },

    onDelete: function (data) {
      var index = this.findIndex(data.id);
      this.$delete(this.messages, index);
      this.postprocess();
    },


    onSync: function (data) {
      this.loading = false;
      this.messages = data;
      if (this.options.compact) {
        this.pagination = false;
      } else {
        this.pagination = data.length == this.options.limit;
        this.postprocess();
      }
    },

    onPaginate: function (data) {
      data.forEach((message) => {
        this.messages.push(message);
      });
      this.pagination = data.length == this.options.limit;
      this.postprocess();
    },

    paginate: function () {
      var last = this.messages[this.messages.length - 1];
      this.lastId = last.id;

	  console.log(this.lastId, this.messages.length);
      if (this.options.live) {
        this.paginateSocket();
      } else {
        this.paginateApi();
      }
    },

    paginateApi: function () {
      // var last = this.messages[this.messages.length - 1];
      // this.lastId = last.id;
      var url = this.options.site + '/index.php?option=com_news&view=liveblogmessages&format=json&id=' + this.options.newsId + '&lastid=' + this.lastId + '&limit=' + this.options.limit;
      axios.get(url).then((response) => {
        this.onPaginate(response.data);
      });
    },

    paginateSocket: function () {
      this.socket.emit('paginate', {
        room: this.options.namespace + ':' + this.options.id,
        id: this.lastId,
        limit: this.options.limit
      });
    },

    postprocess: function () {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(function () {
        if (window.twttr) {
          window.twttr.widgets.load();
        }
        if (window.instgrm) {
          window.instgrm.Embeds.process();
        }
      }, 100);
    },

    findIndex: function (id) {
      return this.messages.findIndex((message) => {
        return message.id == id;
      });
    },

    renderQueue: function () {
      this.queue = [];
      this.scrollToStart();
    },

    isVisible: function () {
      var rectangle = this.$el.getBoundingClientRect();
      return rectangle.top > 0;
    },

    scrollToStart: function () {
      this.$el.scrollIntoView();
    }
  }
}
</script>
